import React, { Component } from 'react'

import styled from 'styled-components'
import TeamMember from '../../molecules/TeamMember/TeamMember'
import ViewMore from './ViewMore'
import person from '../../../images/person.svg'
import TaxonomyHeader from '@/components/TaxonomyHeader'
import TaxonomyHeading from '@/components/TaxonomyHeading'

const Style = styled.div`
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;
  padding: 32px 0px 50px;
  clear: both;
`

export default class TeamMembers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
    this.toggleMore = this.toggleMore.bind(this)
  }

  toggleMore() {
    this.setState({ open: !this.state.open })
  }
  render() {
    return (
      <>
        <TaxonomyHeader>
          <img
            src={person}
            className="mr-2"
          />
          <TaxonomyHeading tag="h3">Professional Staff</TaxonomyHeading>
        </TaxonomyHeader>

        <Style
          open={this.props.open}
          style={{ maxWidth: '1200px', margin: 'auto' }}
        >
          <ViewMore
            label="View More Team Members"
            count={4}
            wrapper={Style}
            render={this.props.data.map((member, i) => (
              <TeamMember
                image={
                  member.image && member.image.includes('cloudinary')
                    ? `https://res.cloudinary.com/rehabpath/image/upload/c_fill,w_300,h_300/${member.image
                        .split('/')
                        .pop()}`
                    : member.image
                }
                name={member.name}
                position={member.position}
                qualifications={member.qualifications}
                key={member.name}
              />
            ))}
          />
        </Style>
      </>
    )
  }
}
